// Module
var code = `<ex-multi-occurrence-maitre-details-ecran multi-occurrence-options="vm.multiOccurrenceOptions" multi-occurrence-out="vm.multiOccurrence" lbl-titre="LBL_TITRE_QPC"></ex-multi-occurrence-maitre-details-ecran>`;
// Exports
module.exports = code;